import type { Locale } from "./en";

// Russian translations. Missing keys fall back to English via i18next.
export const ru: Locale = {
  common: {
    home: "Главная",
    no_scores: "Пока нет очков",
    points_count_one: "{{count}} очко",
    points_count_other: "{{count}} очков",
    questions_count_one: "{{count}} вопрос",
    questions_count_other: "{{count}} вопросов",
  },
  home: {
    placeholder: "Код игры",
    enter: "Войти",
    error_invalid_code: "Введи 6-значный код игры от учителя.",
    footer: "Запусти Binogi Buzz из продуктов Binogi.com.",
    language_label: "Язык",
  },
  errors: {
    generic: "Что-то пошло не так. Попробуй ещё раз.",
    stale_client: "Страница устарела — обнови её.",
    session_not_found: "Сессия не найдена.",
    session_not_open: "Эта сессия завершена.",
    session_not_active: "Этот вопрос или сессия уже закончились.",
    not_teacher: "Это может сделать только учитель.",
    already_answered: "Ты уже ответил на этот вопрос.",
    wrong_question_index: "Этот вопрос ещё не начался.",
    name_taken: "Это имя уже занято. Попробуй другое.",
    character_busy: "Сейчас не получилось выдать тебе персонажа — попробуй ещё раз.",
  },
  host: {
    input: {
      heading: "Запустить Buzz",
      lead:
        "Введи код урока Binogi, который изучают твои ученики. Мы загрузим вопросы и создадим сессию, которую можно показать на доске.",
      lesson_code_label: "Код урока",
      placeholder_code: "BIH750",
      load_button: "Загрузить урок",
      try_hint: "Попробуй:",
      error_invalid_code: "Введи код урока Binogi, например BIH750.",
      error_not_found: "Урок с кодом {{code}} не найден.",
      error_unreachable: "Не удалось связаться с сервером уроков. Проверь подключение и попробуй ещё раз.",
      error_no_questions: "В уроке {{code}} нет вопросов, которые может использовать Buzz.",
      error_no_level_questions: "В уроке {{code}} нет вопросов выбранного уровня.",
    },
    loading: "Загружаем урок…",
    placeholder_title: "Запустить Binogi Buzz",
    tab_details: "Детали",
    tab_questions: "Вопросы",
    settings: "Настройки",
    number_of_students: "Количество учеников",
    fewer_students: "Меньше учеников",
    more_students: "Больше учеников",
    player_names: "Имена игроков",
    player_anonymous: "Анонимно",
    player_self_chosen: "Ученики выбирают",
    language: "Язык",
    language_teacher: "Учитель выбирает",
    language_students: "Ученики выбирают",
    time_per_question: "Время на вопрос",
    time_option: "{{seconds}} с",
    start_button: "Начать сессию",
    start_disabled: "Укажи размер класса, чтобы начать",
    creating: "Создаём сессию…",
    error_no_questions: "Оставь хотя бы один вопрос перед началом.",
    error_create_failed: "Не удалось создать сессию",
    error_load_failed: "Не удалось загрузить урок",
    no_session: "Нет активной сессии.",
    back_to_review: "Назад к вопросам",
    errors: {
      dismiss: "Закрыть",
      refresh: "Обновить",
      attach_failed: "Этот экран не смог подключиться как учитель.",
      unreachable: "Не удалось связаться с сервером. Обнови страницу, чтобы попробовать ещё раз.",
      no_token: "Эта вкладка больше не может управлять викториной. Открой Buzz из своего урока, чтобы начать новую сессию.",
      taken_over: "Теперь эта викторина управляется с другого экрана.",
      stale_question: "Buzz обновился во время викторины, поэтому этот экран не может её продолжить. Перезагрузи страницу, чтобы продолжить викторину с того места, где сейчас класс.",
      question_moved_on: "Викторина уже ушла дальше, поэтому этот экран отстал. Перезагрузи страницу, чтобы продолжить викторину с того места, где сейчас класс.",
    },
    entry: {
      opening: "Открываем экран учителя…",
      token_title: "Эту ссылку учителя нельзя открыть",
      token_body: "В ссылке нет ключа учителя, или срок её действия истёк. Открой Buzz из своего урока, чтобы создать новую сессию.",
      not_found_title: "Сессия не найдена",
      not_found_body: "Этой сессии викторины больше нет. Создай новую, чтобы продолжить.",
      back: "На главную",
    },
    questions: {
      drag_aria: "Перетащи, чтобы изменить порядок",
      remove_aria: "Удалить вопрос",
      empty: "В этой сессии не осталось вопросов.",
      add: "Добавить",
      add_aria: "Добавить вопрос: {{text}}",
      add_all: "Добавить все",
      add_all_n: "Добавить все {{count}} вопросов",
      more_one: "Ещё {{count}} вопрос в этом уроке",
      more_few: "Ещё {{count}} вопроса в этом уроке",
      more_many: "Ещё {{count}} вопросов в этом уроке",
      more_other: "Ещё {{count}} вопросов в этом уроке",
      level_easy: "Лёгкий",
      level_medium: "Средний",
      level_hard: "Сложный",
      multi: "Несколько",
    },
    lobby: {
      go_to: "Зайди на <strong>buzz.binogi.com</strong> и введи:",
      or_qr: "…или отсканируй QR-код",
      students_joined_of: "Присоединилось {{joined}} из {{expected}} учеников",
      students_joined_one: "{{count}} ученик присоединился",
      students_joined_other: "{{count}} учеников присоединились",
      waiting: "Ждём, пока ученики присоединятся…",
      start_game: "Начать игру",
      connected: "Подключено",
      connecting: "Подключаемся…",
      copy_link: "Скопировать ссылку",
      copy_link_copied: "Скопировано!",
    },
    question: {
      header: "Вопрос {{index}} из {{total}}",
      level: "Уровень {{level}}",
      none: "Нет активного вопроса.",
      answered: "Ответили",
      top_n: "Топ {{count}}",
      answers_heading: "Ответы",
      end_question: "Завершить вопрос",
      next_question: "Следующий вопрос",
      see_results: "Посмотреть итоговые результаты",
    },
    results: {
      heading: "Итоговые результаты",
      all_players: "Все игроки",
      end_session: "Завершить сессию",
      new_session: "Новая сессия",
      none: "В этой сессии нет игроков.",
    },
  },
  join: {
    code_label: "Код игры",
    name_label: "Твоё имя",
    name_placeholder: "Введи своё имя",
    join_button: "Присоединиться",
    joining: "Присоединяемся…",
    checking: "Проверяем…",
    character_hint: "Когда присоединишься, получишь весёлое имя персонажа Binogi.",
    error_not_found:
      "Этот код пока не относится к активной сессии. Уточни у учителя.",
    error_lookup_failed: "Не удалось найти сессию",
    error_code_required: "Введи 6-значный код.",
    error_name_required: "Введи своё имя.",
  },
  play: {
    superseded: "Вы подключены в другой вкладке — закройте её, чтобы продолжить игру здесь.",
    back_to_join: "Вернуться ко входу",
    no_round: "Нет данных раунда.",
    not_joined: "Ты не присоединился ни к одной сессии.",
    no_question: "Нет активного вопроса.",
    keep_awake_hint: "Нажми на экран, чтобы он не гас",
    waiting: {
      you_are: "Ты —",
      get_ready_named: "Приготовься, {{name}}!",
      get_ready: "Приготовься к викторине!",
      in_room_label: "Учеников в комнате",
      in_room_one: "{{count}} ученик в комнате",
      in_room_other: "{{count}} учеников в комнате",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Ответ принят!",
      times_up: "Время вышло",
      submit: "Отправить",
      submit_n: "Отправить {{count}} ответов",
    },
    between: {
      correct: "Правильно!",
      wrong: "Почти!",
      times_up: "Время вышло",
      points_gained: "+{{count}} очков",
      your_score: "Твой счёт",
      your_rank: "Место {{rank}}",
      top_n: "Топ {{count}}",
      waiting_next: "Ждём следующий вопрос…",
    },
    finished: {
      heading: "Спасибо за игру в Binogi Buzz!",
      your_final_rank: "Твоё итоговое место",
      top_n: "Топ {{count}}",
      none: "Нет результатов для показа.",
    },
  },
  characters: {
    heading: "Персонажи Binogi",
    lead: "{{count}} учеников получают персонажа при входе, в этом порядке.",
  },
};
